export default {
  // 標題
  title: "掃碼綁定",

  // 加載提示
  loading: "拼命加載中",

  // 平台名稱
  wechat: "微信",
};
